import { Environment } from '@abp/ng.core';

const baseUrl = 'https://login.hyyak.com';
const guestUrl = 'https://hyyak.com';
const hostUrl = 'https://host.hyyak.com';

const oAuthConfig = {
  issuer: 'https://auth.hyyak.com/',
  redirectUri: baseUrl,
  clientId: 'Hyyak_Admin',
  responseType: 'code',
  scope: 'offline_access Hyyak',
  requireHttps: true,
};

export const environment = {
  guestUrl,
  hostUrl,
  production: true,
  application: {
    baseUrl,
    name: 'Hyyak',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://api.hyyak.com',
      rootNamespace: 'Hyyak',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  // remoteEnv: {
  //   url: '/getEnvConfig',
  //   mergeStrategy: 'deepmerge',
  // },
} as Environment;